module.exports = __webpack_public_path__ + "lazerSlideAlt.webp?6f161ef7dd23364a5fdcda3b3a04381c";